/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	CreateSmartLinkEmbedMutation$data as CreateSmartLinkEmbedMutation,
	CreateSmartLinkEmbedMutation$variables as CreateSmartLinkEmbedMutationVariables,
} from '../__generated__/CreateSmartLinkEmbedMutation.graphql.ts';

// Nested types extracted from Relay-generated types
import type { CreateSmartLinkEmbedMutation$data } from '../__generated__/CreateSmartLinkEmbedMutation.graphql.ts';
export type CreateSmartLinkEmbedMutation_createContentContextual_space = NonNullable<NonNullable<CreateSmartLinkEmbedMutation$data['createContentContextual']>['space']>;
export type CreateSmartLinkEmbedMutation_createContentContextual = NonNullable<CreateSmartLinkEmbedMutation$data['createContentContextual']>;

// GraphQL input types re-exported from Relay artifact
export type { ContentSpecificCreateInput } from '../__generated__/CreateSmartLinkEmbedMutation.graphql.ts';

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}

